import { ISelectOption } from 'ui-toolkit';
import StringMethods from './StringMethods';

const getOptionFromSnakeCase = (value: string | null): ISelectOption | null => {
  return value
    ? {
        label: StringMethods.snakeCaseToCapitalize(value),
        value,
      }
    : null;
};

export default getOptionFromSnakeCase;
